//////////////////////////////////////////////////////////////////////////////
/////////////////////Testing Code:::///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import classes from './CanteenPay.module.scss';
import { closePaymenu } from './../../../Redux/action/interactions';
import { canteenPay, walletHistory } from './../../../API/API';
import PayMenu from './PayMenu';
import PayMenuNew from './PayMenuNew';
import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
import RateFood from './RateFood';
import { closePayMenuNew } from './../../../Redux/action/interactions';

const CanteenPay = () => {
    const data = JSON.parse(localStorage.getItem('data'));
    const modules = JSON.parse(localStorage.getItem('modules'));
    const userID = localStorage.getItem('userID');
    const payMenu = useSelector((state) => state.interactions.payMenu);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [transHistory, setHistory] = useState([]);
    const [showRateFood, setShowRateFood] = useState(false);
    const [selectedToken, setSelectedToken] = useState(null);
    const [showPayMenuNew, setShowPayMenuNew] = useState(false);

    useEffect(() => {
        if (modules !== null && modules.includes('CANTEEN') !== true) {
            navigate('/dashboard/home');
            toast("Sorry You Can't Access this Link", {
                icon: '❗',
                duration: 4500,
            });
        }

        if (userID !== null && data !== null) {
            walletHistory(userID, data.empid, data.token)
                .then((response) => {
                    setHistory(response.data);
                })
                .catch(() => {
                    setHistory([]);
                    toast("Unable to Fetch Wallet History", {
                        icon: '❗',
                        duration: 4500,
                    });
                });
        }
        localStorage.removeItem('order');
    }, [userID, payMenu]);

    const handleTokenClick = (token_no) => {
        setSelectedToken(token_no);
        setShowRateFood(true);
    };

    const handleNewPayClick = () => {
        setShowPayMenuNew(false);
        setTimeout(() => {
            setShowPayMenuNew(true);
        }, 0);
        dispatch(closePayMenuNew(true));
    };

    const isToday = (dateString) => {
        const today = new Date();
        const tokenDate = new Date(dateString);
        return (
            tokenDate.getDate() === today.getDate() &&
            tokenDate.getMonth() === today.getMonth() &&
            tokenDate.getFullYear() === today.getFullYear()
        );
    };
    
    return (
        <>
            <BreadCrumb name="Canteen Pay" />
            <div className={classes.Container}>
                {payMenu && <PayMenu />}
                <div className={classes.WalletBalance}>
                    <div className={classes.Amount}>
                        <h2>Wallet Balance</h2>
                        <h1 className={classes.AmountValue}>
                            ₹ {transHistory.length > 0 ? transHistory[0].total : ' '}
                        </h1>
                    </div>
                    <div className={classes.NewPayButton}>
                        <button onClick={handleNewPayClick}>PAY</button>
                    </div>
                </div>
                <div className={classes.History}>
                    <table>
                        <tbody>
                            <tr>
                                <th>Date and Time</th>
                                <th>Amount</th>
                                <th>Token</th>
                            </tr>
                            {transHistory.length > 0 ? (
                                transHistory.map((item, index) => (
                                    <tr key={index}>
                                        <td align="center">
                                            <p>
                                                {item.trans_date.split(' ')[0]} <br />
                                                {item.trans_date.split(' ')[1].split('.')[0]}
                                            </p>
                                        </td>
                                        <td align="center">
                                            {item.rch_type === 'R' ? (
                                                <p style={{ color: '#47D316', fontWeight: 'bold' }}>+ ₹ {item.cr_amt}</p>
                                            ) : (
                                                <p style={{ color: '#EA6A47', fontWeight: 'bold' }}>- ₹ {item.dr_amt}</p>
                                            )}
                                        </td>
                                        <td align="center">
                                            {/* Show clickable button for today's tokens, and a disabled button for others */}
                                            <button
                                                onClick={() => isToday(item.trans_date) && handleTokenClick(item.token_no)}
                                                className={classes.TokenButton}
                                                disabled={!isToday(item.trans_date)} // Disable the button if not today
                                                style={{
                                                    cursor: isToday(item.trans_date) ? 'pointer' : 'not-allowed',
                                                    opacity: isToday(item.trans_date) ? 1 : 0.5,
                                                }}
                                            >
                                                {item.token_no} {isToday(item.trans_date) }
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3">Loading Transaction History</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {showRateFood && selectedToken && (
                    <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
                )}
                {showPayMenuNew && <PayMenuNew />}
            </div>
        </>
    );
};

export default CanteenPay;



//////////////////////////////////////////////////////////////////////////////////////////
////////////////////Testing code of remove the overlapping or glich////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PayMenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';
// import { closePayMenuNew } from './../../../Redux/action/interactions';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector((state) => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [showPayMenuNew, setShowPayMenuNew] = useState(false);

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500,
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then((response) => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500,
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         setShowPayMenuNew(false);
//         setTimeout(() => {
//             setShowPayMenuNew(true);
//         }, 0);
//         dispatch(closePayMenuNew(true));
//     };

//     const isToday = (dateString) => {
//         const today = new Date();
//         const tokenDate = new Date(dateString);
//         return (
//             tokenDate.getDate() === today.getDate() &&
//             tokenDate.getMonth() === today.getMonth() &&
//             tokenDate.getFullYear() === today.getFullYear()
//         );
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : ' '}
//                         </h1>
//                     </div>
//                     <div className={classes.NewPayButton}>
//                         <button onClick={handleNewPayClick}>PAY</button>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align="center">
//                                             <p>
//                                                 {item.trans_date.split(' ')[0]} <br />
//                                                 {item.trans_date.split(' ')[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align="center">
//                                             {item.rch_type === 'R' ? (
//                                                 <p style={{ color: '#47D316', fontWeight: 'bold' }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: '#EA6A47', fontWeight: 'bold' }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align="center">
//                                             {/* Show clickable button for today's tokens, and a disabled button for others */}
//                                             <button
//                                                 onClick={() => isToday(item.trans_date) && handleTokenClick(item.token_no)}
//                                                 className={classes.TokenButton}
//                                                 disabled={!isToday(item.trans_date)} // Disable the button if not today
//                                                 style={{
//                                                     cursor: isToday(item.trans_date) ? 'pointer' : 'not-allowed',
//                                                     //opacity: isToday(item.trans_date) ? 1 : 0.5,
//                                                 }}
//                                             >
//                                                 {item.token_no} {isToday(item.trans_date) }
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//                 {showPayMenuNew && <PayMenuNew />}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;




// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu, closePayMenuNew } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PayMenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector((state) => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [showPayMenuNew, setShowPayMenuNew] = useState(false);

//     useEffect(() => {
//         if (modules !== null && !modules.includes('CANTEEN')) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500,
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then((response) => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500,
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         setShowPayMenuNew(false);
//         setTimeout(() => {
//             setShowPayMenuNew(true);
//         }, 0);
//         dispatch(closePayMenuNew(true));
//     };

//     const isToday = (dateString) => {
//         const today = new Date();
//         const tokenDate = new Date(dateString);
//         return (
//             tokenDate.getDate() === today.getDate() &&
//             tokenDate.getMonth() === today.getMonth() &&
//             tokenDate.getFullYear() === today.getFullYear()
//         );
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : ' '}
//                         </h1>
//                     </div>
//                     <div className={classes.NewPayButton}>
//                         <button onClick={handleNewPayClick}>PAY</button>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align="center">
//                                             <p>
//                                                 {item.trans_date.split(' ')[0]} <br />
//                                                 {item.trans_date.split(' ')[1].split('.')[0]}
//                                             </p>
                                            
//                                         </td>
//                                         <td align="center">
//                                             {item.rch_type === 'R' ? (
//                                                 <p style={{ color: '#47D316', fontWeight: 'bold' }}>
//                                                     + ₹ {item.cr_amt}
//                                                 </p>
//                                             ) : (
//                                                 <p style={{ color: '#EA6A47', fontWeight: 'bold' }}>
//                                                     - ₹ {item.dr_amt}
//                                                 </p>
//                                             )}
//                                         </td>
//                                         <td align="center">
//                                             <button>
//                                             <p
//                                                 onClick={() =>
//                                                     isToday(item.trans_date) && handleTokenClick(item.token_no)
//                                                 }
//                                                 style={{
//                                                     color: isToday(item.trans_date) ? '#007bff' : '#6c757d',
//                                                     //textDecoration: isToday(item.trans_date) ? 'underline' : 'none',
//                                                     cursor: isToday(item.trans_date) ? 'pointer' : 'default',
//                                                     //opacity: isToday(item.trans_date) ? 1 : 0.5,

//                                                     fontWeight: 'bold',
//                                                     margin: 0,
                                                    
//                                                 }}
//                                             >
//                                                 {item.token_no}
//                                             </p>
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//                 {showPayMenuNew && <PayMenuNew />}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;













// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import toast from 'react-hot-toast';
// // import classes from './CanteenPay.module.scss';
// // import { closePaymenu } from './../../../Redux/action/interactions';
// // import { walletHistory } from './../../../API/API';
// // import PayMenu from './PayMenu';
// // import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';


// // const CanteenPay = () => {
// //     const data = JSON.parse(localStorage.getItem('data'));
// //     const modules = JSON.parse(localStorage.getItem('modules'));
// //     const userID = localStorage.getItem('userID');
// //     const payMenu = useSelector(state => state.interactions.payMenu);
// //     const dispatch = useDispatch();
// //     const navigate = useNavigate();
// //     const [transHistory, setHistory] = useState([]);
// //     const [showOthersnacks, setShowOthersnacks] = useState(false);

// //     useEffect(() => {
// //         if (modules !== null && modules.includes('CANTEEN') !== true) {
// //             navigate('/dashboard/home');
// //             toast("Sorry You Can't Access this Link", {
// //                 icon: '❗',
// //                 duration: 4500
// //             });
// //         }

// //         if (userID !== null & data !== null) {
// //             walletHistory(userID, data.empid, data.token)
// //                 .then(response => {
// //                     setHistory(response.data)
// //                 })
// //                 .catch(() => {
// //                     setHistory([])
// //                     toast("Unable to Fetch Wallet History", {
// //                         icon: '❗',
// //                         duration: 4500
// //                     });
// //                 })
// //         }
// //         //Code to delete localstored order so that user can pay any amount
// //         localStorage.removeItem('order');
// //     }, [userID,payMenu]);

// //     // const handlePayClick = () => {
// //     //     setShowOthersnacks(true);
// //     //     dispatch(closePaymenu(true));
// //     //      // Set state to show Othersnacks component
// //     // };

// //     const handlePayClick = () => {
// //         dispatch(closePaymenu(true));
// //         //navigate('/dashboard/Othersnacks'); // Navigate to the OtherSnacks component
// //        // navigate('/dashboard/canteenmenu');
// //     };

// //     return (
// //         <>
// //             <BreadCrumb name="Canteen Pay" />
// //              <div className={classes.Container}>
// //                 {payMenu && <PayMenu />}
// //                  <div className={classes.WalletBalance}>
// //                     <div className={classes.Amount}>
// //                         <h2>
// //                             Wallet Balance
// //                         </h2>
// //                         <h1 className={classes.AmountValue}>
// //                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
// //                         </h1>
// //                     </div>

// //                     {/* <div className={classes.PayButton}>
// //                         <button onClick={handlePayClick}>PAY</button>
// //                     </div> */}
// //                     {/* <div><button>{<OtherSnacks />}PAY</button></div> */}

// //                     <div className={classes.PayButton}>
// //                         <button onClick={()=>{dispatch(closePaymenu(true))}}>PAY</button>
// //                     </div>

// //                 </div>

                

// //                 <div className={classes.History}>
// //                     <table>
// //                         <tbody>
// //                             <tr>
// //                                 <th>Date and Time</th>
// //                                 <th>Amount</th>
// //                                 <th>Token</th>
// //                             </tr>
// //                             {transHistory.length > 0 || transHistory !==null ? (
// //                                 transHistory.map((item, index) => {

// //                                     return (
// //                                         <tr key={index}>
// //                                             <td align='center'>{
// //                                                 <p>
// //                                                     {item.trans_date.split(" ")[0]} <br />
// //                                                     {item.trans_date.split(" ")[1].split('.')[0]}
// //                                                 </p>
// //                                             }</td>
// //                                             <td align='center'>{item.rch_type === "R" ? <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p> : <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>}</td>
// //                                             <td align='center'>{item.token_no}</td>
// //                                         </tr>
// //                                     )

// //                                 })
// //                             ) : (
// //                                 <tr>
// //                                     <td>Loading Transaction History</td>
// //                                     <td>Loading Transaction History</td>
// //                                 </tr>
// //                              )
// //                             }
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             </div>
// //         </>
// //     )
// // }

// // export default CanteenPay






// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import toast from 'react-hot-toast';
// // import classes from './CanteenPay.module.scss';
// // import { closePaymenu } from './../../../Redux/action/interactions';
// // import { walletHistory } from './../../../API/API';
// // import PayMenu from './PayMenu';
// // import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// // import RateFood from './RateFood';

// // const CanteenPay = () => {
// //     const data = JSON.parse(localStorage.getItem('data'));
// //     const modules = JSON.parse(localStorage.getItem('modules'));
// //     const userID = localStorage.getItem('userID');
// //     const payMenu = useSelector(state => state.interactions.payMenu);
// //     const dispatch = useDispatch();
// //     const navigate = useNavigate();
// //     const [transHistory, setHistory] = useState([]);
// //     const [showRateFood, setShowRateFood] = useState(false);
// //     const [selectedToken, setSelectedToken] = useState(null);

// //     useEffect(() => {
// //         if (modules !== null && modules.includes('CANTEEN') !== true) {
// //             navigate('/dashboard/home');
// //             toast("Sorry You Can't Access this Link", {
// //                 icon: '❗',
// //                 duration: 4500
// //             });
// //         }

// //         if (userID !== null & data !== null) {
// //             walletHistory(userID, data.empid, data.token)
// //                 .then(response => {
// //                     setHistory(response.data)
// //                 })
// //                 .catch(() => {
// //                     setHistory([])
// //                     toast("Unable to Fetch Wallet History", {
// //                         icon: '❗',
// //                         duration: 4500
// //                     });
// //                 })
// //         }
// //         localStorage.removeItem('order');
// //     }, [userID, payMenu]);

// //     const handlePayClick = () => {
// //         dispatch(closePaymenu(true));
// //     };

// //     const handleTokenClick = (token) => {
// //         setSelectedToken(token);
// //         setShowRateFood(true);
// //     };

// //     return (
// //         <>
// //             <BreadCrumb name="Canteen Pay" />
// //             <div className={classes.Container}>
// //                 {payMenu && <PayMenu />}
// //                 <div className={classes.WalletBalance}>
// //                     <div className={classes.Amount}>
// //                         <h2>Wallet Balance</h2>
// //                         <h1 className={classes.AmountValue}>
// //                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
// //                         </h1>
// //                     </div>
// //                 </div>
// //                 <div className={classes.History}>
// //                     <table>
// //                         <tbody>
// //                             <tr>
// //                                 <th>Date and Time</th>
// //                                 <th>Amount</th>
// //                                 <th>Token</th>
// //                             </tr>
// //                             {transHistory.length > 0 ? (
// //                                 transHistory.map((item, index) => (
// //                                     <tr key={index}>
// //                                         <td align='center'>
// //                                             <p>
// //                                                 {item.trans_date.split(" ")[0]} <br />
// //                                                 {item.trans_date.split(" ")[1].split('.')[0]}
// //                                             </p>
// //                                         </td>
// //                                         <td align='center'>
// //                                             {item.rch_type === "R" ? (
// //                                                 <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
// //                                             ) : (
// //                                                 <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
// //                                             )}
// //                                         </td>
// //                                         <td align='center'>
// //                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
// //                                                 {item.token_no}
// //                                             </button>
// //                                         </td>
// //                                     </tr>
// //                                 ))
// //                             ) : (
// //                                 <tr>
// //                                     <td colSpan="3">Loading Transaction History</td>
// //                                 </tr>
// //                             )}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //                 {showRateFood && selectedToken && (
// //                     <RateFood token={selectedToken} onClose={() => setShowRateFood(false)} />
// //                 )}
// //             </div>
// //         </>
// //     );
// // };

// // export default CanteenPay;









// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);

//     useEffect(() => {
//         if (modules !== null && !modules.includes('CANTEEN')) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID && data) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//     };
    
//     const handleTokenClick = (token) => {
//         setSelectedToken(token);
//         setShowRateFood(true);
//     };

//     return (
//         <>
//           <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>                    
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>                      
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}                           
//                         </h1>
//                         </div>
//                         <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                      </div>

                    
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.slice(0, 30).map((item, index) => (
//                                 <tr key={index}>
//                                     <td align='center'>
//                                         <p>
//                                             {item.trans_date.split(" ")[0]} <br />
//                                             {item.trans_date.split(" ")[1].split('.')[0]}
//                                         </p>
//                                     </td>
//                                     <td align='center'>
//                                         {item.rch_type === "R" ? (
//                                             <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                         ) : (
//                                             <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                         )}
//                                     </td>
//                                     <td align='center'>
//                                         {item.rch_type !== "R" && (
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no}
//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                             {transHistory.length === 0 && (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';


// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showOthersnacks, setShowOthersnacks] = useState(false);

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null & data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//         //Code to delete localstored order so that user can pay any amount
//         localStorage.removeItem('order');
//     }, [userID,payMenu]);

//     // const handlePayClick = () => {
//     //     setShowOthersnacks(true);
//     //     dispatch(closePaymenu(true));
//     //      // Set state to show Othersnacks component
//     // };

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//         //navigate('/dashboard/Othersnacks'); // Navigate to the OtherSnacks component
//        // navigate('/dashboard/canteenmenu');
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//              <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                  <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>
//                             Wallet Balance
//                         </h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
//                         </h1>
//                     </div>

//                     {/* <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                     </div> */}
//                     {/* <div><button>{<OtherSnacks />}PAY</button></div> */}

//                     <div className={classes.PayButton}>
//                         <button onClick={()=>{dispatch(closePaymenu(true))}}>PAY</button>
//                     </div>

//                 </div>

                

//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 || transHistory !==null ? (
//                                 transHistory.map((item, index) => {

//                                     return (
//                                         <tr key={index}>
//                                             <td align='center'>{
//                                                 <p>
//                                                     {item.trans_date.split(" ")[0]} <br />
//                                                     {item.trans_date.split(" ")[1].split('.')[0]}
//                                                 </p>
//                                             }</td>
//                                             <td align='center'>{item.rch_type === "R" ? <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p> : <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>}</td>
//                                             <td align='center'>{item.token_no}</td>
//                                         </tr>
//                                     )

//                                 })
//                             ) : (
//                                 <tr>
//                                     <td>Loading Transaction History</td>
//                                     <td>Loading Transaction History</td>
//                                 </tr>
//                              )
//                             }
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default CanteenPay






// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null & data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//     };

//     const handleTokenClick = (token) => {
//         setSelectedToken(token);
//         setShowRateFood(true);
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
//                         </h1>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align='center'>
//                                             <p>
//                                                 {item.trans_date.split(" ")[0]} <br />
//                                                 {item.trans_date.split(" ")[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align='center'>
//                                             {item.rch_type === "R" ? (
//                                                 <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align='center'>
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no}
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;














// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// //import { closePaymenu } from './../../../Redux/action/interactions';
// import {closePayMenuGeneric} from '../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// //import PayMenu from './PayMenu';
// import PayMenuGeneric from './PayMenuGeneric';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const payMenuGeneric = useSelector(state => state.interactions.payMenuGeneric);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);

//     useEffect(() => {
//         if (modules !== null && !modules.includes('CANTEEN')) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID && data) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenuGeneric]);

//     // const handlePayClick = () => {
//     //     dispatch(closePaymenu(true));
//     // };

//     const handlePayClick = () => {
//         dispatch(closePayMenuGeneric(true));
//     }
    
//     const handleTokenClick = (token) => {
//         setSelectedToken(token);
//         setShowRateFood(true);
//     };

//     return (
//         <>
//           <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenuGeneric && <PayMenuGeneric />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>                    
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>                      
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}                           
//                         </h1>
//                         </div>
//                         <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                      </div>
                    
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.slice(0, 30).map((item, index) => (
//                                 <tr key={index}>
//                                     <td align='center'>
//                                         <p>
//                                             {item.trans_date.split(" ")[0]} <br />
//                                             {item.trans_date.split(" ")[1].split('.')[0]}
//                                         </p>
//                                     </td>
//                                     <td align='center'>
//                                         {item.rch_type === "R" ? (
//                                             <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                         ) : (
//                                             <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                         )}
//                                     </td>
//                                     <td align='center'>
//                                         {item.rch_type !== "R" && (
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no}
//                                             </button>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                             {transHistory.length === 0 && (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;











// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PaymenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [amount, setAmount] = useState(0);

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//     };

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         dispatch(closePaymenu(true)); 
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
//                         </h1>
//                     </div>
//                     <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                     </div>

//                     {/* ////////////////////   New Pay Menu    //////////////////*/}
//                      <div className={classes.NewPayButton}>                       
//                         <button onClick={handleNewPayClick}> {<PaymenuNew/>}PAY</button>                       
//                     </div>    
                                   
//                    {/* ////////////////////////////////////////////////////////// */}


//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align='center'>
//                                             <p>
//                                                 {item.trans_date.split(" ")[0]} <br />
//                                                 {item.trans_date.split(" ")[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align='center'>
//                                             {item.rch_type === "R" ? (
//                                                 <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align='center'>
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no}
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;





/////////////////////////// MAIN BACKUP CODE ////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PayMenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';
// import {closePayMenuNew} from './../../../Redux/action/interactions';


// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [amount, setAmount] = useState(0);
//     const [showPayMenuNew, setShowPayMenuNew] = useState(false); // State to manage PayMenuNew visibility

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data)
//                 })
//                 .catch(() => {
//                     setHistory([])
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 })
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//     };

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         setShowPayMenuNew(true); // Show the PayMenuNew component
//         //dispatch(closePayMenuNew(true));
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
//                         </h1>
//                     </div>
//                     <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                     </div>

//                     {/* New Pay Button */}
//                     <div className={classes.NewPayButton}>
//                         <button onClick={handleNewPayClick}>PAY NEW</button>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align='center'>
//                                             <p>
//                                                 {item.trans_date.split(" ")[0]} <br />
//                                                 {item.trans_date.split(" ")[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align='center'>
//                                             {item.rch_type === "R" ? (
//                                                 <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align='center'>
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no}
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//                 {showPayMenuNew && <PayMenuNew />} 
//             </div>
//         </>
//     );
// };

// export default CanteenPay;







//////////////////////Running Code/////////////////////////

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PayMenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';
// import { closePayMenuNew } from './../../../Redux/action/interactions';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector(state => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [amount, setAmount] = useState(0);
//     const [showPayMenuNew, setShowPayMenuNew] = useState(false); // State to manage PayMenuNew visibility

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then(response => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handlePayClick = () => {
//         dispatch(closePaymenu(true));
//     };

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         setShowPayMenuNew(false); // Close the PayMenuNew component if it was already open
        
//         setTimeout(() => {
//             setShowPayMenuNew(true); // Reopen the PayMenuNew component after it closes
//         }, 0);

//         // Additional logic, such as a payment process, could go here.
//         dispatch(closePayMenuNew(true));
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : " "}
//                         </h1>
//                     </div>
//                     {/* <div className={classes.PayButton}>
//                         <button onClick={handlePayClick}>PAY</button>
//                     </div> */}

//                     {/* New Pay Button */}
//                     <div className={classes.NewPayButton}>
//                         <button onClick={handleNewPayClick}>PAY</button>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align='center'>
//                                             <p>
//                                                 {item.trans_date.split(" ")[0]} <br />
//                                                 {item.trans_date.split(" ")[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align='center'>
//                                             {item.rch_type === "R" ? (
//                                                 <p style={{ color: "#47D316", fontWeight: "bold" }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: "#EA6A47", fontWeight: "bold" }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align='center'>
//                                             <button onClick={() => handleTokenClick(item.token_no)} className={classes.TokenButton}>
//                                                 {item.token_no} T
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//                 {showPayMenuNew && <PayMenuNew />}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;



//////////////////////////////////////////////////////////////////////////////
/////////////////////Testing Code:::///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import classes from './CanteenPay.module.scss';
// import { closePaymenu } from './../../../Redux/action/interactions';
// import { walletHistory } from './../../../API/API';
// import PayMenu from './PayMenu';
// import PayMenuNew from './PayMenuNew';
// import BreadCrumb from '../../../utilities/BreadCrumb/BreadCrumb';
// import RateFood from './RateFood';
// import { closePayMenuNew } from './../../../Redux/action/interactions';

// const CanteenPay = () => {
//     const data = JSON.parse(localStorage.getItem('data'));
//     const modules = JSON.parse(localStorage.getItem('modules'));
//     const userID = localStorage.getItem('userID');
//     const payMenu = useSelector((state) => state.interactions.payMenu);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const [transHistory, setHistory] = useState([]);
//     const [showRateFood, setShowRateFood] = useState(false);
//     const [selectedToken, setSelectedToken] = useState(null);
//     const [showPayMenuNew, setShowPayMenuNew] = useState(false);

//     useEffect(() => {
//         if (modules !== null && modules.includes('CANTEEN') !== true) {
//             navigate('/dashboard/home');
//             toast("Sorry You Can't Access this Link", {
//                 icon: '❗',
//                 duration: 4500,
//             });
//         }

//         if (userID !== null && data !== null) {
//             walletHistory(userID, data.empid, data.token)
//                 .then((response) => {
//                     setHistory(response.data);
//                 })
//                 .catch(() => {
//                     setHistory([]);
//                     toast("Unable to Fetch Wallet History", {
//                         icon: '❗',
//                         duration: 4500,
//                     });
//                 });
//         }
//         localStorage.removeItem('order');
//     }, [userID, payMenu]);

//     const handleTokenClick = (token_no) => {
//         setSelectedToken(token_no);
//         setShowRateFood(true);
//     };

//     const handleNewPayClick = () => {
//         setShowPayMenuNew(false);
//         setTimeout(() => {
//             setShowPayMenuNew(true);
//         }, 0);
//         dispatch(closePayMenuNew(true));
//     };

//     const isToday = (dateString) => {
//         const today = new Date();
//         const tokenDate = new Date(dateString);
//         return (
//             tokenDate.getDate() === today.getDate() &&
//             tokenDate.getMonth() === today.getMonth() &&
//             tokenDate.getFullYear() === today.getFullYear()
//         );
//     };

//     return (
//         <>
//             <BreadCrumb name="Canteen Pay" />
//             <div className={classes.Container}>
//                 {payMenu && <PayMenu />}
//                 <div className={classes.WalletBalance}>
//                     <div className={classes.Amount}>
//                         <h2>Wallet Balance</h2>
//                         <h1 className={classes.AmountValue}>
//                             ₹ {transHistory.length > 0 ? transHistory[0].total : ' '}
//                         </h1>
//                     </div>
//                     <div className={classes.NewPayButton}>
//                         <button onClick={handleNewPayClick}>PAY</button>
//                     </div>
//                 </div>
//                 <div className={classes.History}>
//                     <table>
//                         <tbody>
//                             <tr>
//                                 <th>Date and Time</th>
//                                 <th>Amount</th>
//                                 <th>Token</th>
//                             </tr>
//                             {transHistory.length > 0 ? (
//                                 transHistory.map((item, index) => (
//                                     <tr key={index}>
//                                         <td align="center">
//                                             <p>
//                                                 {item.trans_date.split(' ')[0]} <br />
//                                                 {item.trans_date.split(' ')[1].split('.')[0]}
//                                             </p>
//                                         </td>
//                                         <td align="center">
//                                             {item.rch_type === 'R' ? (
//                                                 <p style={{ color: '#47D316', fontWeight: 'bold' }}>+ ₹ {item.cr_amt}</p>
//                                             ) : (
//                                                 <p style={{ color: '#EA6A47', fontWeight: 'bold' }}>- ₹ {item.dr_amt}</p>
//                                             )}
//                                         </td>
//                                         <td align="center">
//                                             {/* Show clickable button for today's tokens, and a disabled button for others */}
//                                             <button
//                                                 onClick={() => isToday(item.trans_date) && handleTokenClick(item.token_no)}
//                                                 className={classes.TokenButton}
//                                                 disabled={!isToday(item.trans_date)} // Disable the button if not today
//                                                 style={{
//                                                     cursor: isToday(item.trans_date) ? 'pointer' : 'not-allowed',
//                                                     opacity: isToday(item.trans_date) ? 1 : 0.5,
//                                                 }}
//                                             >
//                                                 {item.token_no} {isToday(item.trans_date) }
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3">Loading Transaction History</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 {showRateFood && selectedToken && (
//                     <RateFood token_no={selectedToken} onClose={() => setShowRateFood(false)} />
//                 )}
//                 {showPayMenuNew && <PayMenuNew />}
//             </div>
//         </>
//     );
// };

// export default CanteenPay;
















